import {useWindowSize} from "../../../core/hooks/common/useWindowSize";
import {useState} from "react";
import {TABLET_SIZE} from "../../../core/constants/common";
import RContractTable from "../../../components/responsive/main/reports/contract/RContractTable";
import ContractTable from "../../../components/main/reports/contract/ContractTable";
import FilterLayout from "../../../components/layout/filter/FilterLayout";
import {CacheKeys, contractFilterOptions, contractSortOptions} from "../../../core/constants/filter";
import {useListContracts} from "../../../core/services/react-query/report/contract";
import ListLayout from "../../../components/layout/main/ListLayout";
import {PageCard} from "../../../styles/CommonStyles";



const Contract = () => {

    const { width } = useWindowSize()

    const [contracts, setContracts] = useState({loading: true, data: null})
    const onUserQuery = res => setContracts(res)

    const Component = width > TABLET_SIZE ? ContractTable : RContractTable

    return (
        <ListLayout>
            <PageCard>
                <FilterLayout
                    query={useListContracts}
                    options={contractFilterOptions}
                    onQuerySuccess={onUserQuery}
                    cache={CacheKeys.CONTRACT}
                    sortOptions={contractSortOptions}
                >
                    <Component data={contracts} />
                </FilterLayout>
            </PageCard>
        </ListLayout>
    )
}

export default Contract
